import { styled } from 'styletron-react';
import { TechemTheme } from '@techem/techem-theme';
import { md } from '../../../theme/mediaQueries';

export const Card = styled('div', {
  paddingTop: '32px',
  paddingRight: '32px',
  paddingBottom: '32px',
  paddingLeft: '32px',
  backgroundColor: TechemTheme.colors.backgroundSecondary,
  color: TechemTheme.colors.contentPrimary,
  [md]: {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px'
  },
  boxSizing: 'border-box'
});
